"use strict";
exports.__esModule = true;
exports.FrequenciesEnum = void 0;
var FrequenciesEnum;
(function (FrequenciesEnum) {
    FrequenciesEnum["Weekly"] = "weekly";
    FrequenciesEnum["Always"] = "always";
    FrequenciesEnum["Hourly"] = "hourly";
    FrequenciesEnum["Daily"] = "daily";
    FrequenciesEnum["Monthly"] = "monthly";
    FrequenciesEnum["Yearly"] = "yearly";
    FrequenciesEnum["Never"] = "never";
})(FrequenciesEnum = exports.FrequenciesEnum || (exports.FrequenciesEnum = {}));
//# sourceMappingURL=page.js.map